import { styled } from '@mui/material/styles';
import logoImage from 'assets/images/logo-header.svg';

export const HeaderLogo = styled('div')({
  width: '200px',
  height: '48px',
  background: `url(${logoImage}) no-repeat`,
  backgroundSize: 'cover',
})